import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Locales
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enLegal from './locales/en/legal.json';
import enHowItWorks from './locales/en/howItWorks.json';

import esCommon from './locales/es/common.json';
import esHome from './locales/es/home.json';
import esLegal from './locales/es/legal.json';
import esHowItWorks from './locales/es/howItWorks.json';

import frCommon from './locales/fr/common.json';
import frHome from './locales/fr/home.json';
import frLegal from './locales/fr/legal.json';
import frHowItWorks from './locales/fr/howItWorks.json';

import deCommon from './locales/de/common.json';
import deHome from './locales/de/home.json';
import deLegal from './locales/de/legal.json';
import deHowItWorks from './locales/de/howItWorks.json';

import filCommon from './locales/fil/common.json';
import filHome from './locales/fil/home.json';
import filLegal from './locales/fil/legal.json';
import filHowItWorks from './locales/fil/howItWorks.json';

import jaCommon from './locales/ja/common.json';
import jaHome from './locales/ja/home.json';
import jaLegal from './locales/ja/legal.json';
import jaHowItWorks from './locales/ja/howItWorks.json';

import ptCommon from './locales/pt/common.json';
import ptHome from './locales/pt/home.json';
import ptLegal from './locales/pt/legal.json';
import ptHowItWorks from './locales/pt/howItWorks.json';

import itCommon from './locales/it/common.json';
import itHome from './locales/it/home.json';
import itLegal from './locales/it/legal.json';
import itHowItWorks from './locales/it/howItWorks.json';

import plCommon from './locales/pl/common.json';
import plHome from './locales/pl/home.json';
import plLegal from './locales/pl/legal.json';
import plHowItWorks from './locales/pl/howItWorks.json';

import zhCommon from './locales/zh/common.json';
import zhHome from './locales/zh/home.json';
import zhLegal from './locales/zh/legal.json';
import zhHowItWorks from './locales/zh/howItWorks.json';

export const resources = {
  en: {
    common: enCommon,
    home: enHome,
    legal: enLegal,
    howItWorks: enHowItWorks,
  },
  es: {
    common: esCommon,
    home: esHome,
    legal: esLegal,
    howItWorks: esHowItWorks,
  },
  fr: {
    common: frCommon,
    home: frHome,
    legal: frLegal,
    howItWorks: frHowItWorks,
  },
  de: {
    common: deCommon,
    home: deHome,
    legal: deLegal,
    howItWorks: deHowItWorks,
  },
  fil: {
    common: filCommon,
    home: filHome,
    legal: filLegal,
    howItWorks: filHowItWorks,
  },
  ja: {
    common: jaCommon,
    home: jaHome,
    legal: jaLegal,
    howItWorks: jaHowItWorks,
  },
  pt: {
    common: ptCommon,
    home: ptHome,
    legal: ptLegal,
    howItWorks: ptHowItWorks,
  },
  it: {
    common: itCommon,
    home: itHome,
    legal: itLegal,
    howItWorks: itHowItWorks,
  },
  pl: {
    common: plCommon,
    home: plHome,
    legal: plLegal,
    howItWorks: plHowItWorks,
  },
  zh: {
    common: zhCommon,
    home: zhHome,
    legal: zhLegal,
    howItWorks: zhHowItWorks,
  },
};

// Also support 'tl' and regional country codes
resources.tl = resources.fil;
resources['zh-CN'] = resources.zh;
resources['zh-TW'] = resources.zh;
resources['zh-HK'] = resources.zh;
resources['pt-BR'] = resources.pt;
resources['pt-PT'] = resources.pt;
resources['ja-JP'] = resources.ja;
resources['it-IT'] = resources.it;
resources['pl-PL'] = resources.pl;

const detectorOptions = {
  order: ['localStorage', 'navigator', 'htmlTag'],
  lookupLocalStorage: 'i18nextLng',
  caches: ['localStorage'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'legal', 'howItWorks'],
    detection: detectorOptions,
    interpolation: {
      escapeValue: false, // React already escapes values safely
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
